export default __webpack_public_path__ + "media/zurb/img/events/wired/pie-ranch/pie-ranch-thumb-fe4e20f86859fb47994ce6a27256f48d.png";